<template>
  <div>
    <listado-acuerdos-clientes-base-tabla
      :data="data"
      :dataInicial="dataInicial"
      :getListaAcuerdosClientesBase="getListaAcuerdosClientesBase"
      :load="load"
    />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

import { getAcuerdosClientesBase, 
getListasAcuerdosBase, 
getContratosPorNavieraYTipo } from "@/constants/lineas";
import ListadoAcuerdosClientesBaseTabla from "../../../components/tablas/lineas/ListadoAcuerdosClientesBaseTabla";

export default {
  components: { ListadoAcuerdosClientesBaseTabla },
  data() {
    return {
      data: [],
      load: false,
      dataInicial: [],
    };
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("lineas", ["dataDatatableTarifasAcuerdosClientesBase"]),
  },
  methods: {
    // Acciones de Vuex
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoadingTable",
      "ActionSetClientes",
      "ActionSetNavieras",
      "ActionSetAtmosferas",
      "ActionSetContenedores",
      "ActionSetCommodity",
      "ActionSetContratos",
      "ActionSetDestinos",
      "ActionSetPod",
      "ActionSetPol"
    ]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosClientesBase",
      "actionSetSelectCommodities",
      "actionSetSelectAtmospheres",
      "actionSetSelectContainers",
      "actionSetSelectContract",
      "actionSetDataListaPOD",
      "actionSetDataListaPOL",
      "actionSetDataListaNavierasNoUCC"
    ]),
    actualizarURL() {

      this.AccionCambiar(this.$route.path);

    },

    // Obteneción de acuerdos cliente desde la BD
    async getListaAcuerdosClientesBase() {
      this.load = true;
      this.ActionSetLoadingTable(true);

      const {
        data_table,
        filtros_clientes,
        filtros_atmosferas,
        filtros_contenedor,
        filtros_contratos,
        filtros_navieras,
        filtros_navieras_no_ucc,
        filtros_productos,
        filtros_destinos,
        filtros_pod,
        filtros_pol
      } = await getAcuerdosClientesBase(  );

      const { lista_prod_categories, lista_atmosferas, lista_contenedores } = await getListasAcuerdosBase();
      
      this.actionSetSelectAtmospheres( filtros_atmosferas );
      this.actionSetSelectContainers( filtros_contenedor );
      this.actionSetSelectCommodities( filtros_productos );

      const result = await getContratosPorNavieraYTipo({ type: 1});
      this.actionSetSelectContract(result);

      this.actionSetDataListarTarifasAcuerdosClientesBase(data_table);
      this.ActionSetClientes(filtros_clientes);
      this.ActionSetNavieras(filtros_navieras);
      this.actionSetDataListaNavierasNoUCC(filtros_navieras_no_ucc);
      this.ActionSetAtmosferas(lista_atmosferas);
      this.ActionSetContenedores(lista_contenedores);
      this.ActionSetCommodity(lista_prod_categories);
      this.ActionSetContratos(filtros_contratos);
      this.ActionSetDestinos(filtros_destinos);
      // this.ActionSetPod(filtros_pod);
      // this.ActionSetPol(filtros_pol);

      this.actionSetDataListaPOD(filtros_pod);
      this.actionSetDataListaPOL(filtros_pol);

      this.ActionSetPod(filtros_pod.filter( p => p.id !== "NULL" && p.id !== undefined ) );
      this.ActionSetPol(filtros_pol.filter( p => p.id !== "NULL" && p.id !== undefined ) );

      this.load = false;
    },
  },
  created() {
    this.getListaAcuerdosClientesBase();
    this.actualizarURL();
  },
  watch: {
    dataDatatableTarifasAcuerdosClientesBase: function (_new) {
      if (_new) {
        this.data = _new;
      }
    },
  },
};
</script>
<style></style>
